




































import Vue from "vue";
import Component from "vue-class-component";
import { AppGroupService as appGroupApi } from "@/common/api/services/AppGroupService";
import { AwsService as awsApi } from "@/common/api/services/AwsService";
import qNotify from "@/common/qNotify";

@Component({
  name: "BlogIndex",
})
export default class BlogIndex extends Vue {
  files = [];

  params: any = {
    page: 1,
    groupId: 1,
    direction: "desc",
    sort: "post_date",
    status: ["release"],
  };

  mounted() {
    this.params.groupId = Number.parseInt(
      this.$router.currentRoute.params.groupId
    );
  }

  async getList($state) {
    try {
      const result = await appGroupApi.userGroupFiles(this.params);

      if (result.data.list.length > 0) {
        this.params.page += 1;
        this.files = [...this.files, ...result.data.list];
        $state.loaded();
      } else {
        $state.complete();
      }
    } catch (error) {
      $state.complete();
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  async download(file) {
    try {
      const result = await awsApi.awsDownloadFilePresign({
        filePath: file.files[0].name,
        filename: file.files[0].nameOriginal,
      });

      window.open(result.data.presign.url || "");
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }
}
